
    // Function to get a cookie by name
  const   getCookie = (cookieName: string): string | null =>{
      const name = cookieName + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(';');
  
      for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
  
      return null;
    }
  
  
  
  // Export the instance to be consumed elsewhere
  export default getCookie;
  